import { Card, CardContent, CardHeader, CardTitle, Grid, Stack, Switch } from '@forto-dev/phoenix-ui-core/common'

import { useSetShipUserPreference, useShipUserPreference } from '@/features/auth'
import { useLocalisation } from '@/utils/localisation'

export const Preferences = () => {
  const setShipUserPreference = useSetShipUserPreference()
  const { data: shipPrefersLegacyData } = useShipUserPreference(true)
  const handleSetShipPrefersLegacy = (checked: boolean) => {
    if (checked) {
      setShipUserPreference.mutate()
    }
  }
  const { translate } = useLocalisation()

  return (
    <Card>
      <CardHeader>
        <CardTitle>{translate('settings.preferences.title')}</CardTitle>
      </CardHeader>
      <CardContent>
        <Stack gap={16}>
          <Grid col={2} gap={16}>
            <Switch
              label={translate('settings.preferences.prefer_legacy_ship')}
              checked={!!shipPrefersLegacyData?.owner?.[0].value.useLegacyUI}
              onCheckedChange={handleSetShipPrefersLegacy}
            />
          </Grid>
        </Stack>
      </CardContent>
    </Card>
  )
}
